export function normalize(chaine, lower = true) {
  if (!chaine) return null
  let res = chaine
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

  if (lower) return res.toLowerCase()

  return res
}

export function toCurrencyEUR(amount) {
  return amount
    ? amount
        ?.toLocaleString('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2,
        })
        .replace('.', ',')
    : '0 €'
}
